// extracted by mini-css-extract-plugin
export default {"dividerDiv":"Divider_dividerDiv__GeJO1"};